export const EMAIL_SENDS = 'email_sends';
export const API_CALLS_DAILY = 'api-calls-daily';